import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageSection, Button } from '@gik/ui';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import SamplePagesGrid from '@gik/marketing/components/SamplePages/SamplePagesGrid';
import Link from '@/components/Link';
import routes from '@gik/core/routes';

export interface ISamplePagesSectionProps extends React.HTMLAttributes<HTMLUListElement> {}

export default function TipsSamplePagesSection({ className }: ISamplePagesSectionProps): React.ReactElement {
  const bem = bemBlock('how-it-works-sample-pages-section');
  const { t } = useTranslation();

  return (
    <PageSection className={bem(null, null, className)} id="sample-pages">
      <h2 className={bem('title')}>{t(translationKeys.samplePagesTitle)}</h2>
      <SamplePagesGrid skeletonItems={5} perPage={5} />
      <Link href={routes.tipsAndSamplePages + '#sample-pages'}>
        <Button className={bem('see-more')} variant="primary-link">
          {t(translationKeys.seeMoreLink)}
        </Button>
      </Link>
    </PageSection>
  );
}
